import {User} from "@instantdb/react";
import {RouterProvider} from "@tanstack/react-router";
import {AuthProvider, useAuth} from "./providers/auth-provider";
import {Providers} from "./providers/providers";
import {router} from "./router";

const InnerApp = () => {
  const auth = useAuth();
  return (
    <RouterProvider
      router={router}
      context={{
        auth: {
          user: auth?.user as User,
          profiles: auth?.initData?.data?.profiles,
          isProfilesReady: auth?.isProfilesReady || false,
          isLoading: auth?.isLoading || false,
          initData: auth?.initData,
        },
      }}
    />
  );
};

export const App = () => {
  return (
    <Providers>
      <AuthProvider>
        <InnerApp />
      </AuthProvider>
    </Providers>
  );
};

export default App;
